import React, { useState } from 'react';
import styles from './ReviewCard.module.scss';
import RatingComponent from '../../../../../commons/components/ui/mui5/Rating/Rating';
import QuoteIcon from '../../../../../src/assets/images/icons/quote_icon.svg';
import Image from 'next/image';
import { ProductsCategory } from '../../../../../config';
import { Typography } from '@mui/material';
const miniProdCardClassMap = {
  [ProductsCategory.RELIEF_FACTOR]: styles.rel,
  [ProductsCategory.GO_FACTOR]: styles.gof,
  [ProductsCategory.ZEN_FACTOR]: styles.zen,
  [ProductsCategory.Z_FACTOR]: styles.zfa,
};

const ReviewCard = ({ review }) => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.reviewCardContainer}>
          <div
            className={`${styles.reviewCardBox} ${
              miniProdCardClassMap[review?.product]
            }`}
          >
            <div className={styles.reviewCardContentBox}>
              <div className={styles.reviewCardContentReviewer}>
                {/* Keeping it as it is if in future if we want to show the rating*/}
                {/* <div>
                  <div>
                    <RatingComponent value={review?.rating} />
                  </div>
                </div> */}
                <div className={styles.reviewCardContentReviewerChild}>
                  <div className={styles.reviewQuoteContainer}>
                    <QuoteIcon />
                  </div>
                  <Typography
                    variant="h3"
                    className={styles.reviewContent}
                    dangerouslySetInnerHTML={{ __html: review?.reviewContent }}
                  >
                    {/* {review?.reviewContent} */}
                  </Typography>
                  <div className={styles.reviewerContainer}>
                    {/* Keeping it as it is if in future if we want to show user image*/}
                    {/* <div className={styles.reviewerImage}>
                      <Image
                        layout="fill"
                        src={review?.userImg}
                        loading="eager"
                        objectFit="contain"
                        // loader={imgLoader}
                        className={styles.userImage}
                      />
                    </div> */}
                    <Typography variant="p1" className={styles.reviewerDetails}>
                      {review?.username}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewCard;
